const datepicker = () => {
  const date = new Datepicker('#BirthDate');
  const dateModal = new Datepicker('#BirthDate-modal');
}

export default datepicker;